import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/privacy-policy')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="h-svh overflow-y-auto">
      <div className="mx-auto my-8 max-w-5xl space-y-4">
        <h1 className="text-center text-lg">
          <strong>POLÍTICA DE PRIVACIDADE</strong>
        </h1>
        <p>
          <strong>1. APRESENTAÇÃO E OBJETO</strong>
          <br />
          Esta Política de Privacidade tem por finalidade estabelecer, de forma
          clara, objetiva e acessível, as regras para a coleta, utilização,
          armazenamento, proteção, compartilhamento e demais formas de
          tratamento de dados pessoais dos <strong>
            Revisores Médicos
          </strong>{' '}
          cadastrados na Plataforma Digital GPMED, administrada por GPMED LTDA,
          pessoa jurídica de direito privado, inscrita no CNPJ sob o nº
          50.327.373/0001-40, com sede em São José do Rio Preto/SP.
        </p>
        <p>
          A GPMED LTDA atua como <strong>Controladora de Dados Pessoais</strong>
          , nos termos da Lei nº 13.709/2018 – Lei Geral de Proteção de Dados
          Pessoais (LGPD), adotando práticas de segurança da informação e
          governança em privacidade em conformidade com:
          <p className="ml-4">
            – Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018);
          </p>
          <p className="ml-4">
            – Marco Civil da Internet (Lei nº 12.965/2014);
          </p>
          <p className="ml-4">
            – Lei de Direitos Autorais (Lei nº 9.610/1998);
          </p>
          <p className="ml-4">
            – Demais normas aplicáveis ao ambiente digital, educacional e
            tecnológico.
          </p>
        </p>
        <p>
          <strong>2. DEFINIÇÕES</strong>
          <br />
          Aplicam-se as definições previstas na LGPD, incluindo: dados pessoais,
          dados pessoais sensíveis, titular, tratamento, controladora, operador
          e encarregado (DPO).
        </p>
        <p>
          <strong>3. IDENTIFICAÇÃO DO CONTROLADOR E DPO</strong>
          <br />
          GPMED LTDA
          <br />
          CNPJ: 50.327.373/0001-40
          <br />
          Sede: Av. Presidente Juscelino Kubitschek de Oliveira, nº 1600 –
          Jardim Tarraf II – São José do Rio Preto/SP – CEP 15092-415
          <br />
          Canal de contato com o Encarregado de Dados (DPO):
          <br />
          contato@oguiadeprescricao.com.br
        </p>
        <p>
          <strong>4. CATEGORIAS DE DADOS TRATADOS</strong>
          <br />
          A GPMED poderá tratar os seguintes dados dos Revisores Médicos:
          <br />
          <strong className="ml-4">4.1 Dados fornecidos pelo titular</strong>
          <p className="ml-4">– nome completo;</p>
          <p className="ml-4">– CPF;</p>
          <p className="ml-4">– CRM e especialidade;</p>
          <p className="ml-4">– e-mail e telefone;</p>
          <p className="ml-4">– dados bancários para pagamento;</p>
          <p className="mb-4 ml-4">
            – dados profissionais e acadêmicos, quando aplicável.
          </p>
          <strong className="ml-4">4.2 Dados coletados automaticamente</strong>
          <p className="ml-4">– endereço IP;</p>
          <p className="ml-4">– logs de acesso;</p>
          <p className="ml-4">– informações de dispositivo e navegador;</p>
          <p className="mb-4 ml-4">– registros de atividades na plataforma.</p>
          <strong className="ml-4">4.3 Dados sensíveis</strong>
          <p className="ml-4">
            Em regra, a GPMED não realiza tratamento de dados pessoais sensíveis
            dos Revisores, exceto quando estritamente necessário para
            cumprimento de obrigações legais ou exercício regular de direitos.
          </p>
        </p>

        <p>
          <strong>5. FINALIDADES DO TRATAMENTO</strong>
          <br />
          Os dados pessoais dos Revisores Médicos são tratados para:
          <br />
          <p className="ml-4">
            – cadastro, autenticação e validação profissional;
          </p>
          <p className="ml-4">– gestão das atividades de revisão técnica;</p>
          <p className="ml-4">
            – processamento de pagamentos e obrigações fiscais;
          </p>
          <p className="ml-4">
            – cumprimento de obrigações legais, regulatórias e contratuais;
          </p>
          <p className="ml-4">
            – prevenção a fraudes e incidentes de segurança;
          </p>
          <p className="ml-4">
            – auditoria, governança e controle de qualidade editorial;
          </p>
          <p className="ml-4">
            – defesa em processos judiciais, administrativos ou arbitrais.
          </p>
        </p>

        <p>
          <strong>6. BASES LEGAIS</strong>
          <br />
          O tratamento é fundamentado, conforme o caso, em:
          <br />
          <p className="ml-4">
            – execução de contrato ou procedimentos preliminares (art. 7º, V,
            LGPD);
          </p>
          <p className="ml-4">
            – cumprimento de obrigação legal ou regulatória (art. 7º, II);
          </p>
          <p className="ml-4">– exercício regular de direitos (art. 7º, VI);</p>
          <p className="ml-4">– legítimo interesse da GPMED (art. 7º, IX);</p>
          <p className="ml-4">
            – consentimento do titular, quando aplicável (art. 7º, I).
          </p>
        </p>

        <p>
          <strong>7. COMPARTILHAMENTO DE DADOS</strong>
          <br />
          Os dados dos Revisores poderão ser compartilhados com:
          <br />
          <p className="ml-4">– provedores de tecnologia e hospedagem;</p>
          <p className="ml-4">
            – plataformas de pagamento e instituições financeiras;
          </p>
          <p className="ml-4">
            – prestadores de serviços de segurança da informação;
          </p>
          <p className="ml-4">
            – autoridades públicas e órgãos reguladores, quando exigido por lei
            ou ordem judicial.
          </p>
          O compartilhamento observará os princípios da finalidade, necessidade,
          adequação, segurança e responsabilização, com contratos específicos
          com operadores contendo cláusulas de confidencialidade e proteção de
          dados.
        </p>

        <p>
          <strong>8. COOKIES E REGISTROS DE ACESSO</strong>
          <br />
          Poderão ser utilizados cookies estritamente necessários e tecnologias
          de registro de acesso para autenticação, segurança, auditoria e
          prevenção a fraudes. O uso de cookies analíticos observará as
          preferências do titular.
        </p>

        <p>
          <strong>9. ARMAZENAMENTO E RETENÇÃO</strong>
          <br />
          Os dados serão armazenados de forma segura e retidos pelo período
          necessário para:
          <p className="ml-4">– execução do contrato;</p>
          <p className="ml-4">– cumprimento de obrigações legais e fiscais;</p>
          <p className="ml-4">– exercício regular de direitos da GPMED.</p>
          Após, poderão ser anonimizados ou eliminados de forma segura.
        </p>

        <p>
          <strong>10. DIREITOS DO TITULAR</strong>
          <br />O Revisor poderá exercer os direitos previstos no art. 18 da
          LGPD, inclusive: confirmação de tratamento, acesso, correção,
          anonimização quando cabível, informação sobre compartilhamento,
          portabilidade quando aplicável e revogação de consentimento, por meio
          do DPO.
        </p>

        <p>
          <strong>11. SEGURANÇA E GOVERNANÇA</strong>
          <br />A GPMED adota medidas técnicas e administrativas adequadas,
          incluindo controle de acesso, criptografia quando aplicável, logs de
          auditoria, monitoramento de incidentes, capacitação de colaboradores e
          manutenção de ROPA (art. 37, LGPD), além de DPIA quando necessário.
        </p>

        <p>
          <strong>12. TRANSFERÊNCIA INTERNACIONAL</strong>
          <br />
          Poderá haver transferência internacional de dados em razão do uso de
          infraestrutura em nuvem, com adoção de garantias contratuais e
          técnicas compatíveis com a LGPD e regulamentação da ANPD.
        </p>

        <p>
          <strong>13. INCIDENTES DE SEGURANÇA</strong>
          <br />
          Em caso de incidente relevante, a GPMED adotará medidas de contenção e
          comunicará a ANPD e os titulares, quando exigido.
        </p>

        <p>
          <strong>14. ATUALIZAÇÕES</strong>
          <br />
          Esta Política poderá ser atualizada. A versão vigente será publicada
          com data de atualização.
        </p>

        <p>
          <strong>15. DISPOSIÇÕES FINAIS</strong>
          <br />
          Esta Política integra os Termos de Uso do Revisor Médico da GPMED. A
          continuidade do uso da plataforma implica ciência da versão vigente.
        </p>

        <p>
          <strong>16. LEGISLAÇÃO E FORO</strong>
          <br />
          Aplica-se a legislação brasileira.
          <br />
          Foro da Comarca de São José do Rio Preto/SP.
        </p>
      </div>
    </div>
  );
}
